import {CommonModule, DatePipe} from '@angular/common';
import {
    AfterContentInit,
    AfterViewInit,
    Component,
    DestroyRef,
    Inject,
    inject,
    InjectionToken,
    OnInit,
    signal,
    ViewChild
} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu';
import {PageEvent} from '@angular/material/paginator';
import {
    BehaviorSubject,
    catchError,
    combineLatest, debounceTime,
    filter,
    first,
    Observable,
    of,
    shareReplay,
    switchMap,
    tap
} from 'rxjs';
import {DataTableService} from '../../../core/services/data-table.service';
import {TableActionDirective} from '../../../shared/components/table/table-action.directive';
import {TableCellDirective} from '../../../shared/components/table/table-cell.directive';
import {TableComponent} from '../../../shared/components/table/table.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialog} from '@angular/material/dialog';
import {ActivatedRoute} from '@angular/router';
import {SideBarDoubleComponent} from '../../../shared/components/side-bar-double/side-bar-double.component';


import {RemarkTypeTable} from '../../apiModule/model/remarktype';
import {Sort} from '@angular/material/sort';
import {CommunicationService} from '../../../core/services/communication.service';
import * as XLSX from 'xlsx';
import {FilterIndicatorsBarComponent} from '../register/filter-indicators-bar/filter-indicators-bar.component';
import {RegisterHeaderComponent} from '../register/register-header/register-header.component';
import {IndexEntityService} from '../../apiModule1';
import {IndexTableService} from './columns-index.service';
import {DialogComponent} from './dialog/dialog.component';
import {FilterDialogComponent} from './filter-dialog/filter-dialog.component';
import {PasFiltersStoreService} from '../../../core/services/pas-store.service';
import {PasFilterType} from '../../../shared/components/side-bar-double/menu-data.service';
import {DialogDeleteComponent} from './dialogForDelete/dialog-delete.component';
import {EntityConfigService} from './entity-config.service';
import {ApiService} from '../../apiModule1/api/ApiService';
import {ComponentType} from '@angular/cdk/overlay';
import {CapitalizePipe} from '../../../core/pipes/capitalize.pipe';
import {UserPermissionsService} from '../../../core/services/user-permissions.service';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {CurrentUserService} from "../../../core/services/user.service";
import {PagerStoreService} from "../../../core/services/pager-store.service";
import {SearchStoreService} from "../../../core/services/search-store.service";

export type ContentMenuItems = { open?: string, edit?: string, restore?: string, delete?: string }

export interface FilterData {
    fillType?: FillType[] | null;
    indexEntityIds?: IndexEntry[] | null;
    statusId?: Status[] | null;
}

export const CURRENT_ENTITY_TOKEN = new InjectionToken<string>('CurrentEntity');
export const DataService = new InjectionToken('DataService');
export const EmptyPager = {
    length: 0,
    pageIndex: 1,
    pageSize: 10,
    previousPageIndex: 0
}

@Component({
    selector: 'pas-index',
    standalone: true,
    imports: [
        CommonModule,
        TableComponent,
        TableCellDirective,
        TableActionDirective,
        MatIcon,
        MatIconButton,
        MatMenu,
        MatMenuTrigger,
        RegisterHeaderComponent,
        MatSidenavModule,
        MatDatepickerModule,
        FormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        SideBarDoubleComponent,
        DatePipe,
        FilterIndicatorsBarComponent,
        CapitalizePipe,
        MatProgressSpinnerModule,

    ],
    templateUrl: './index-entity.component.html',
    styleUrl: './index-entity.component.scss',
    providers: [
        {provide: DataTableService, useClass: IndexTableService},
        {provide: CURRENT_ENTITY_TOKEN, useValue: 'indexEntity'},
        {provide: DataService, useClass: IndexEntityService},
        {provide: DialogComponent, useClass: DialogComponent},
    ]
})
export class IndexEntityComponent implements OnInit, AfterContentInit {
    @ViewChild(TableComponent) table: TableComponent<any> | null = null;

    // filterComponent = FilterRemarktypeComponent;

    contentMenuItems: ContentMenuItems = {
        edit: 'Редактировать',
        delete: 'Архивировать',
        restore: 'Восстановить',
    };

    canUseEdit = false;
    canUseDelete = false;
    canUseRestore = false;

    entityConfig = inject(EntityConfigService);

    protected type: PasFilterType = 'index-entity'
    protected mainMethod = ''
    protected methodGetId = ''
    protected methodSetstatus = ''
    protected methodPost: string;
    protected methodPut: string;
    protected titleCreate: string

    public opened = true;
    mobileOpen = false;
    public searchPhrase: string = '';
    private readonly emptyPager = EmptyPager;


    search$ = new BehaviorSubject<string>('');
    sort$ = new BehaviorSubject<Sort>({direction: '', active: ''});
    filters$ = new BehaviorSubject<any | null>(null);
    filtersFromDialog$ = new BehaviorSubject<any | null>(null);
    pager$ = new BehaviorSubject<PageEvent>(this.emptyPager);

    searchObservable$ = this.search$.asObservable().pipe(shareReplay(1));
    sortObservable$ = this.sort$.asObservable();
    filtersObservable$ = this.filters$.asObservable();
    pagerObservable$ = this.pager$.asObservable().pipe(shareReplay(1));


    communicationService = inject(CommunicationService);
    filterStore = inject(PasFiltersStoreService);
    permissionsService = inject(UserPermissionsService);
    public accessGranted = false;

    // accessService = inject(AccessService);

    actRoute: ActivatedRoute = inject(ActivatedRoute);
    destroyRef: DestroyRef = inject(DestroyRef);
    dialog: MatDialog = inject(MatDialog);
    currentUserService = inject(CurrentUserService)


    protected dialogComponent: ComponentType<any> = DialogComponent
    protected filterDialogComponent: ComponentType<unknown> = FilterDialogComponent;
    protected postParam = 'apiIndexPostRequest';
    private createNew: object;

    isFinishedDownloadExcel = signal(false)

    userWasLoaded = new BehaviorSubject(false)

    pagerService = inject(PagerStoreService)
    searchService = inject(SearchStoreService)

    constructor(
        public readonly dataTableService: DataTableService,
        @Inject(DataService) public dataService: ApiService,
        @Inject(CURRENT_ENTITY_TOKEN) public currentEntity: string,
    )
    {
        this.currentEntity = currentEntity;
        this.type = this.entityConfig.config[this.currentEntity].type as PasFilterType;
        this.mainMethod = this.entityConfig.config[this.currentEntity].mainMethod;
        this.methodGetId = this.entityConfig.config[this.currentEntity].methodGetId;
        this.methodSetstatus = this.entityConfig.config[this.currentEntity].methodSetstatus;
        this.methodPost = this.entityConfig.config[this.currentEntity].post
        this.methodPut = this.entityConfig.config[this.currentEntity].idPut;
        this.titleCreate = this.entityConfig.config[this.currentEntity].titleCreate;
        this.postParam = this.entityConfig.config[this.currentEntity].postParam;
        this.createNew = this.entityConfig.config[this.currentEntity].createNew;

        // this.actRoute.data.subscribe(data => {
        //     console.log('actRoute.data', data['data']);
        //     this.dataTableService.setData(data['data']);
        // });

        //забираем данные из сторов
        const pagerFromStore = this.pagerService.get(this.currentEntity);
        this.pager$.next(pagerFromStore)

        const searchFromStore = this.searchService.get(this.currentEntity);
        this.search$.next(searchFromStore)
        this.searchPhrase = searchFromStore

        //подписки
        this.searchObservable$.pipe(tap(v => console.log('searchObservable$', v))).subscribe((v: string) => {
            this.pager$.next(this.emptyPager);
            this.table && this.table.setPage({
                page: 1,
                pageSize: 10,
                recordCount: this.pager$.value.length
            });
            this.searchService.set(this.currentEntity,v);
        });

        this.pagerObservable$.pipe(tap(v => console.log('pagerObservable$', v))).subscribe();

        this.filtersFromDialog$.subscribe(v => {
            if (!v) return;
            this.filterStore.set(this.type, v);
        });

        this.refreshData().subscribe((data: { pager: Pager, values: IndexEntry[] }) => {
            this.dataTableService.setData(data);
        });

        //установка начальных данных для таблицы
        this.dataTableService.setData({pager: this.pager$.value, values: []});

        this.currentUserService.user$
            .pipe(filter(user => user!==undefined && Object.keys(user).length>0))
            .subscribe(v=> {
                console.log('_', v)
                this.userWasLoaded.next(!!v)
            })

    }

    refreshData(): Observable<any> {
        return combineLatest([this.searchObservable$, this.sortObservable$, this.filtersObservable$, this.pagerObservable$])
            .pipe(
                debounceTime(500),
                tap(v => console.log('combineLatest', v))
            )
            .pipe(switchMap(() => {
                    return (this.dataService as any)[this.mainMethod](
                        {
                            searchString: this.search$.value,
                            sortColumnName: this.sort$.value.active ? this.sort$.value.active : undefined,
                            sortAscending: this.sort$.value.direction === 'asc' ? true : undefined,
                            ...this.filters$.value,
                            pageIndex: this.pager$.value.pageIndex,
                            pageSize: this.pager$.value.pageSize
                        }
                    );
                }
            ))
            .pipe(catchError(err => {
                console.error(err);
                return of(this.communicationService.publish('ошибка запроса данных', {type: 'error'}));
            }));
    }

    updateList = new BehaviorSubject<void>(undefined);


    getData(): void {
        if (!this.dataService || !this.mainMethod) return;
        (this.dataService as any)[this.mainMethod](
            {
                searchString: this.search$.value,
                sortColumnName: this.sort$.value.active ? this.sort$.value.active : undefined,
                sortAscending: this.sort$.value.direction === 'asc' ? true : undefined,
                ...this.filters$.value,
                pageIndex: this.pager$.value.pageIndex,
                pageSize: this.pager$.value.pageSize
            }
        ).subscribe((v: { pager: PageEvent, values: IndexEntry[] }) => {
            this.dataTableService.setData(v);
        });

    }

    openDialog(data: any, isNew: boolean, idNumber: number = 0): void {
        const method = isNew ? this.methodPost : this.methodPut;
        const id = isNew ? 0 : idNumber;
        this.dialog.open(this.dialogComponent, {
            width: '690px',
            height: '100svh',
            position: {
                right: '0px'
            },
            data: {...data, isNew, id}
        })
            .afterClosed().subscribe((res: any) => {
            // ---закрываем контекстное меню --
            this.table?.menuTriggers.forEach(t => t.closeMenu())

            if (!res) return;

            (this.dataService as any)[method]({id, [this.postParam]: res}).subscribe(
                () => this.getData(),
                (err: any) => {
                    console.error('тест обработки ошибки', err);
                }
            )
        });
    }

    onRowSelected(event: Event, row: { id: number }): void {
        console.log('event', event, row);
        event.stopPropagation();
        event.preventDefault();

        (this.dataService as any)[this.methodGetId]({id: row.id}).subscribe((data: any) => {
            this.openDialog(data, false, row.id);
        });

    };


    onSearch(): void {
        this.search$.next(this.searchPhrase);
    }

    onPageChange(pager: PageEvent): void {
        this.pager$.next(pager);
        this.pagerService.set(this.currentEntity,pager)
    }


    protected _prepareFilterToSend<T extends object>(filterObj: T): Record<keyof T, number[]> {
        let res = Object.entries(filterObj)
        res = res.filter(([_, value]) => value !== null && value !== undefined)
        res = res.map(([k, v]) => {
            return [k, excludeId(v)]
        })
        const result = Object.fromEntries(res) as Record<keyof T, number[]>;
        return result
    }

    openFilterDialog(): void {
        const dialogRef = this.dialog.open(this.filterDialogComponent, {
            width: '690px',
            height: '100vh',
            position: {
                right: '0px'
            },
            data: this.filtersFromDialog$.value,
        });


        //--- filter ---
        dialogRef.afterClosed().subscribe((v) => {
            if (!v) return;
            this.filtersFromDialog$.next(v);
            this.filters$.next(this._prepareFilterToSend(v));
        });

    }

    setPermissionFlags(right: DeepPartial<UserRights> | null): void {
        if (right === null) return;
        this.accessGranted = !!right?.edit?.[this.entityConfig.config[this.currentEntity].access]

        this.canUseDelete = !!right?.common?.menu_archive
        this.canUseRestore = !!right?.common?.menu_reset
        this.canUseEdit = !!right?.common?.menu_open
    }

    ngOnInit(): void {
        this.permissionsService.permissons$.subscribe(v => {
            const edit = v?.edit
            if (!edit) return;
            this.setPermissionFlags(v)
        })

        this.setPermissionFlags(this.permissionsService.permissons$.value)

        const currentFilter = this.filterStore.get(this.type);
        if (!currentFilter) return;
        this.filtersFromDialog$.next(currentFilter);
        this.filters$.next(this._prepareFilterToSend(currentFilter));
    }

    ngAfterContentInit() {
        setTimeout(()=>{
            const res = this.pagerService.get(this.currentEntity)
            this.pager$.next(res)
            this.table && this.table.setExternalPage(res);
        },500)
    }


    deleteElement($event: MouseEvent, element: any): void {
        console.log(element);
        const dialogRef = this.dialog.open(DialogDeleteComponent, {
            width: '30vw',
            data: element,
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (!result) return;
            const id = result.id;
            delete result.id;
            (this.dataService as any)[this.methodSetstatus]({id, apiCriterionSetstatusIdPutRequest: result})
                .subscribe(() => {
                    this.onPageChange(this.pager$.value);
                });
        });
    }

    restoreElement(element: RemarkTypeTable): void {
        // if(!this.accessService.list$.value['registry_archive']) return this.toastService.error('Недостаточно прав');
        // console.log(element);
        (this.dataService as any)[this.methodSetstatus]({
            id: element.id!, apiCriterionSetstatusIdPutRequest: {
                ...element.status,
                statusId: 1
            }
        })
            .subscribe(() => {
                this.onPageChange(this.pager$.value);
            });
    }

    onSortedColumn($event: Sort): void {
        console.log($event);
        this.sort$.next($event);
    }


    public resetFilters(): void {
        this.filters$.next({});
        this.filtersFromDialog$.next({});
    }

    refresh(): void {
        window.location.reload();
    }

    excel(): void {
        const prevPager = this.pager$.value;
        this.refreshData()
            .pipe(first())
            .subscribe(v => {
                if (v.pager?.count !== 1e6) return;
                setTimeout(async () => {
                    const worksheet = XLSX.utils.table_to_sheet(this.table!.tableRef.nativeElement, {raw: true});

                    // @ts-expect-error: тредование XLXS
                    const range = XLSX.utils.decode_range(worksheet['!ref']);
                    console.log('worksheet[\'A1\'].', worksheet['A1']);

                    const lastCol = range.e.c;

// Пройтись по всем строкам и удалить ячейки последнего столбца
                    for (let R = range.s.r; R <= range.e.r; R++) {
                        const cellAddress = XLSX.utils.encode_cell({r: R, c: lastCol});
                        delete worksheet[cellAddress];
                    }

// Обновить диапазон листа, уменьшив количество столбцов на 1
                    range.e.c = lastCol - 1;
                    worksheet['!ref'] = XLSX.utils.encode_range(range);

                    worksheet['!cols'] = _autoFitColumns(worksheet);

                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
                    this.actRoute.title.subscribe(title => {
                        XLSX.writeFile(workbook, title + '.xlsx');
                        this.onPageChange(prevPager);
                    });
                },1000);
            });
        this.onPageChange({
            pageSize: 1e6,
            pageIndex: 1,
            length: this.table!.recordCount
        });
    }

    protected readonly Array = Array;

    onClickOutside(): void {
        if (!this.mobileOpen) return;
        this.mobileOpen = false;
    }

    onCreateNew() {
        this.openDialog(this.createNew, true)
    }


    importFile(inputTemp: HTMLInputElement) {
        console.log(inputTemp);
        inputTemp.click();
    }

    onFileDownload($event: Event): void {
    }
}

export function _autoFitColumns(worksheet: XLSX.WorkSheet): { wch: any }[] {
    // @ts-expect-error: тредование XLXS
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const colWidths = Array(range.e.c + 1).fill(0);

    for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
            const cellAddress = XLSX.utils.encode_cell({r: R, c: C});
            const cell = worksheet[cellAddress];

            if (cell && cell.v) {
                const cellValue = cell.v.toString();
                const cellWidth = cellValue.length;
                colWidths[C] = Math.max(colWidths[C], cellWidth);
            }
        }
    }
    return colWidths.map(width => ({wch: width}));

}

export function excludeId(obj: any[]): any[] | null {
    // if(obj === null || obj.some(v=>!('id' in v))) return null;
    if (obj === null) return null;
    //Если есть id, то возвращаем его. Если элемент не объект, то тоже его возвращаем
    if (typeof obj === 'string' || typeof obj === 'number' || !Array.isArray(obj)) return obj
    return obj.map(v =>
        (typeof v === 'object' && v !== null && ('id' in v)) ? v.id : v
    );
}
